import axios from "axios";
let api;
if (process.env.NODE_ENV == "development") {
  //开发环境
  api = `/api` + "/api"
} else if (process.env.NODE_ENV == "production") {
  //生产环境
  api = `/api`
}

const request = axios.create({ baseURL: api, timeout: 60000 });

// 1.请求拦截器
request.interceptors.request.use(
  (config) => {
    // 请求接口之前 做些什么 1.统一注入token
    let token = window.localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    //2.设置headers icode config.headers.code = ''; 必须返回 config
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 2.响应拦截器
request.interceptors.response.use(
  // 请求成功的处理
  (response) => {
    const { success, code, msg, message, result, status } = response.data;
    // 需要判断当前请求是否成功
    if (success) {
      return result; // 成功后返回解析后的数据
    } else if (code === 200 || code == "00000") {
      return result; // 成功后返回解析后的数据
    } else if (code === 401) {
      // store.dispatch('user/logout'); ElMessage.error(message); // 提示错误信息
    } else {
      // 失败（请求成功 ，业务失败） 弹出消息提示
      return Promise.reject(new Error(message));
    }
  },
  // 请求失败处理
  (error) => {
    //token过期
    return Promise.reject(error);
  }
);

export { request };
